<!--
    课程商品-授权统计
    作用：展示校区授权课程的列表数据
    实现：展示列表数据、导出搜索数据、查看授权账号数详情
    组件：AppList、AppSearch
    版本号: 3.0
-->
<template>
  <div>
    <AppList
      ref="list"
      :list.sync="list"
      :download-label="'导出搜索数据'"
      :download-loading="downloadLoading"
      api="/api/packet/packet-record-list"
      title=""
      @downloadPage="downloadExcel">
      <AppSearch
        slot="search"
        :search-arr="searchArrLive"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="item in columnsLive"
            :key="item.id"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :prop="item.prop"
            :formatter="item.formatter"
          />
          <el-table-column
            label="授权状态"
            width="100px"
            align="center"
          >
            <template slot-scope="{row}">
              <span :class="authClass[row.auth_status]">{{ authType[row.auth_status] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="授权账号数/账号数"
            width="100px"
            align="center"
          >
            <template slot-scope="{row}">
              <el-link
                size="small"
                type="warning"
                @click="authInfo(row)">
              <span style="color:red">{{ filterUserCount(row).length }}</span>/{{ row.users.length }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in columnsLive2"
            :key="item.id"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :prop="item.prop"
            :formatter="item.formatter"
          />
        </el-table>
      </template>
    </AppList>
    <users-info-dialog
      v-if="showUserInfo"
      :visible.sync="showUserInfo"
      :cur-row="curRow"/>
  </div>
</template>
<script>
import usersInfoDialog from './usersInfoDialog.vue';

export default {
  name: 'AuthorityStatistics',
  components: {
    usersInfoDialog,
  },
  data() {
    return {
      showUserInfo: false,
      curRow: {},
      list: {},
      apiUrl: '',
      authType: {
        0: '未授权',
        1: '已授权',
        2: '取消授权',
      },
      authClass: {
        0: 'text-info',
        1: 'text-success',
        2: 'text-danger',
      },
      columnsLive: [
        {
          prop: 'to_clients.review_used.name',
          label: '校区名称',
          minWidth: '100px',
        },
        {
          prop: 'to_clients.school_code',
          label: '校区代码',
          minWidth: '100px',
        }, {
          prop: 'to_clients.review_used.user_mobile',
          label: '校长手机号',
          minWidth: '130px',
        },
        {
          prop: 'packet.name',
          label: '课程名称',
          minWidth: '100px',
        },
        {
          prop: 'packet.code',
          label: '课程编码',
          width: '120px',
        },
        {
          label: '授权形式',
          formatter: (row) => {
            const type = {
              1: '按账号',
              2: '按次数',
            };
            return type[row.auth_type];
          },
        },
        {
          prop: 'used_number',
          label: '上课次数',
        },
        {
          prop: 'auth_number',
          label: '授权次数',
        },
      ],
      columnsLive2: [
        {
          prop: 'created_at',
          width: '100px',
          label: '授权时间',
        },
        {
          prop: 'cancel_auth_time',
          width: '100px',
          label: '取消时间',
        },
        {
          prop: 'created_users.name',
          label: '操作人名称',
          minWidth: '100px',
        },
        {
          prop: 'created_users.mobile',
          label: '操作人账号',
          minWidth: '130px',
        },
        {
          prop: 'from_clients.review_used.name',
          label: '操作校区',
          minWidth: '120px',
        },
      ],
      downloadLoading: false
    };
  },
  computed: {
    searchArrLive() {
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: [
            { value: 1, name: '按账号' },
            { value: 2, name: '按次数' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'auth_type',
          placeholder: '授权形式',
        },
        {
          selectValue: [
            { value: 0, name: '未授权' },
            { value: 1, name: '已授权' },
            { value: 2, name: '取消授权' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'auth_status',
          placeholder: '授权状态',
        },
        { componentType: 'AppSearchColumn',
          searchType: [
            { prop: 'packet_name', label: '课程名称' },
            { prop: 'school_name', label: '校区名称' },
            { prop: 'school_code', label: '校区编码' },
            { prop: 'master_mobile', label: '校长手机' },
            { prop: 'operate_user_name', label: '操作人员' },
            { prop: 'operate_school_name', label: '操作校区' },
          ] },
      ];
    },
  },
  created() {
    this.apiUrl = 'api/packet/packet-record-list';
  },
  methods: {
    authInfo(row) {
      if (row.auth_status) {
        this.curRow = Object.assign(row);
        this.showUserInfo = true;
      }
    },
    // 账号数
    filterUserCount(row) {
      const newArr = [];
      row.users.forEach((item) => {
        if (item.auth_status === 1) {
          newArr.push(item);
        }
      });
      return newArr;
    },
    downloadExcel() {
      this.downloadLoading = true
      const query = Object.keys(this.$route.query)
        .map(key => `${key}=${this.$route.query[key]}`)
        .join('&');
      this.$http.get(`/api/packet/packet-record-list-export?${query}`, { responseType: 'blob' }).then((res) => {
        this.$setting.saveAs(res, '授权统计');
      }).finally(() => {
        this.downloadLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/CourseGoods/AuthorityStatistics/index.vue